import { UiNotificationMenuItem } from '@system-dyg/shared/ui';
import { UiPortalHeaderNotices } from '@system-dyg/shared/ui/portal-layout';

export const PORTAL_CLIENTES_HEADER_NOTICES: UiPortalHeaderNotices = {
  showMessages: false,
  messageCount: 2,
  notificationCount: 5,
  viewAllHref: '/notifications',
  notificationItems: [
    {
      id: 'payment-validated',
      title: 'Pago validado por tesorería',
      datetime: '20/09/2026 - 10:50',
      project: 'Quadrante Ciudad Granja',
      model: 'F',
      unit: '102 A',
      message:
        'Tu pago por $ 30,000.00 del 15/09/2026 fue validado de forma exitosa y aplicado a tu estado de cuenta',
      href: '/departments/quadrante-102-a/payments',
      read: false,
    },
    {
      id: 'payment-rejected',
      title: 'Pago rechazada por tesorería',
      datetime: '01/10/2026 - 12:35',
      project: 'Quadrante Ciudad Granja',
      model: 'F',
      unit: '102 A',
      message:
        'Tu pago por $ 15,000.00 del 30/09/2026 fue rechazado por tesorería favor de verificar el motivo de rechazo y efectuar las acciones para corregirlo',
      href: '/departments/quadrante-102-a/payments',
      read: true,
    },
    {
      id: 'service-follow-up',
      title: 'Seguimiento solicitud de servicio',
      datetime: '24/09/2026 - 19:15',
      project: 'Quadrante Ciudad Granja',
      model: 'F',
      unit: '102 A',
      message:
        'Se ha registrado una nueva actividad de seguimiento ingresa para revisar los detalles',
      href: '/service-requests',
      read: false,
    },
    {
      id: 'signature-request',
      title: 'Solicitud de firma de documento',
      datetime: '01/10/2026 - 12:35',
      context: 'Documento: Nombre del documento',
      project: 'Madison Chapalita',
      model: 'C',
      unit: '805 A',
      message:
        'Se solicito la firma digital del documento ingresa a tu bandeja de firma digital',
      href: '/digital-signature',
      read: true,
    },
    {
      id: 'delivery-schedule',
      title: 'Programación de entrega',
      datetime: '02/10/2026 - 11:55',
      project: 'The Lighthouse Marina Mazatlán',
      model: 'A',
      unit: '304 B',
      message:
        'Se ha liberado tu departamento para entrega, es necesario que ingreses al calendario de entregas y selecciones fecha y hora',
      read: false,
    },
  ] satisfies readonly UiNotificationMenuItem[],
};
